(function () {
    angular.module("skillBuilderSaaS")
        .controller("TranslateCategoryModalCtrl", ["category", "categoryResource", "$q", "notify", "$scope", TranslateCategoryModalCtrl]);
    function TranslateCategoryModalCtrl(category, categoryResource, $q, notify, $scope) {
        var vm = this;
        categoryResource.getTranslations({ number: category.number }, function (result) {
            vm.categoryLocalizations = result.categoryLocalizations;
        });
        vm.checkCategoryNameIsAvailable = function (value, languageCulture, categoryNumber) {
            return $q(function (resolve, reject) {
                //Prevent Server calls before any change on the form.
                if (vm.form.$pristine) {
                    resolve(true);
                }
                else {
                    categoryResource.getIsNameAvailable({
                        name: value,
                        languageCulture: languageCulture,
                        number: categoryNumber
                    }, function (result) {
                        if (result.value)
                            resolve(true);
                        else
                            reject();
                    });
                }
            });
        };
        vm.save = function () {
            if (!vm.form.$valid) {
                vm.showErrors = true;
            }
            else {
                categoryResource.saveTranslations({ number: category.number, categoryLocalizations: vm.categoryLocalizations }, function (result) {
                    $scope.$close(result);
                }, function () {
                    notify({ messageTemplate: "<span>{{ 'common.genericError' | translate }}</span>", classes: "alert-danger" });
                });
            }
        };
    }
}());
